import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "actions";
import RegisteredUsers from "components/Admin/Webinar/RegisteredUsers";

const { loadAdminUsersWebinarsSaga, addAdminUsersWebinars } = actions;

class RegistedUsers extends Component {
  componentDidMount() {
    const { webinarId, id } = this.props.params;

    if (webinarId) {
      this.props.loadAdminUsersWebinars(webinarId);
    } else {
      this.props.loadAdminUsersWebinars(id);
    }
  }

  componentWillMount() {
    this.props.cleanAdminUsersWebinars();
  }

  render() {
    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_webinar_users">
          <RegisteredUsers values={this.props.users} />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.adminWebinarRegisteredUsers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadAdminUsersWebinars: (id) => dispatch(loadAdminUsersWebinarsSaga(id)),
    cleanAdminUsersWebinars: () => dispatch(addAdminUsersWebinars([])),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistedUsers);



// WEBPACK FOOTER //
// ./src/containers/Admin/Webinar/RegisteredUsers.jsx